import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/ReportSelect.html?raw';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
// NOTE (JS2TS): dropped dead dojo deps (dom-construct, dom-attr, dom-style, _base/connect, on).

class ReportSelect extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    item: any = null;
    jsonEntitylist: any = null;

    startup(): void {
        this._initButtonVisibility();
    }

    _initButtonVisibility(): void {
        if (this.item != null) {
            var bCheck = false;

            if (this.item.LvlProjectInfoReport > 0) {
                domClass.remove(this.projectInfoBtn, "w3-hide");
            }
        }
    }


    stopSpinner(): void {
        //spinners.global().stop();
        this.StandbyStop();
    }

    _onClickProjectInfo(evt: any): void {
        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();
        location.href = window.appRoot + "SOV/ProjectGetProjectInfoReport?associateID=" + this.item.ref_associate + "&projectID=" + this.item.ref_ev_project;

        setTimeout(lang.hitch(this, "stopSpinner"), 10000);

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
ReportSelect.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.ReportSelect';

export default mdsWidget(ReportSelect);
